import { axiosWithAuth } from "../../helpers";

export const residualsCommonService = {
	getImportStatuses,
	getSourceTypes,
	getStagesStatus,
};

const RESIDUALS_API_URL = process.env.REACT_APP_API_URL_RESIDUALS;

function getImportStatuses() {
	const options = {
		method: "GET",
		url: `${RESIDUALS_API_URL}/api/resources/source_file/import_statuses`,
	};

	return axiosWithAuth(options);
}

function getSourceTypes() {
	const options = {
		method: "GET",
		url: `${RESIDUALS_API_URL}/api/resources/source_types`,
	};

	return axiosWithAuth(options);
}

function getStagesStatus({ paidYear, paidMonth }) {
	return axiosWithAuth(
		{
			method: "GET",
			url: `${RESIDUALS_API_URL}/api/${paidYear}/${paidMonth}/stages/status`,
		},
		true,
	);
}
